export default __webpack_public_path__ + "static/media/cottage_berries.11419247.jpg";